import { getScheduledTikTokCampaign } from 'src/Redux/schedule-process/tiktokCampaign/selectors'
import { CampaignTypeEnum } from 'src/Types/campaigns'
import {
  useUpdateArtistFeatureFlagsMutation,
  useGetArtistFeatureFlagsQuery,
} from 'src/Redux/A-BFeaturesApi'
import { useTiktokCampaignDetails } from 'src/Redux/campaignTiktokDetailsApi/useTiktokCampaignDetails'

import { useAppSelector } from './redux'

interface UseReels {
  isReelsUser: boolean
  isReelsCampaign: boolean
  isDetailsForReelsCampaign: boolean
  onUnsetReelsFeature: () => void
}

export const REELS_FEATURE_VALUE = 'artist_chose_reels_campaign'

export const useReels = (): UseReels => {
  const [addFeatureForUser] = useUpdateArtistFeatureFlagsMutation()

  const { campaignDetails } = useTiktokCampaignDetails()

  const { data: isReelsUser } = useGetArtistFeatureFlagsQuery(void 0, {
    selectFromResult: (result) => ({
      ...result,
      data: result?.data?.features?.find(
        (item) => item?.name === REELS_FEATURE_VALUE,
      )?.variation,
    }),
  })

  const scheduledCampaign = useAppSelector(getScheduledTikTokCampaign)

  const isReelsCampaign =
    scheduledCampaign.type === CampaignTypeEnum.FIRST && isReelsUser

  const onUnsetReelsFeature = (): void => {
    addFeatureForUser({
      featureName: REELS_FEATURE_VALUE,
      variation: 0,
    })
  }

  const isDetailsForReelsCampaign =
    campaignDetails?.type === CampaignTypeEnum.FIRST && isReelsUser

  return {
    onUnsetReelsFeature,
    isReelsUser: Boolean(isReelsUser),
    isReelsCampaign: Boolean(isReelsCampaign),
    isDetailsForReelsCampaign: Boolean(isDetailsForReelsCampaign),
  }
}
